export default __webpack_public_path__ + "static/media/gc-teal-white@2x.0ddcfd5d.png";